module.exports = __webpack_public_path__ + "img/1.98e4ff22.png";